module.exports = __webpack_public_path__ + "static/media/MT8.4b8d1c05.mp3";